import React, { useEffect, useState } from 'react';
import styles from './HbsArchive.module.css';
import HbsPreview from './HbsPreview';
import { search } from './search';

const n = {
	display: 'inline-block',
	margin: 5,
	height: 30,
	width: 30,
	borderRadius: '50%',
	color: 'rgb(30, 20, 10)',
	cursor: 'pointer',
	border: 'none',
};

const s = {
	display: 'inline-block',
	margin: 5,
	height: 30,
	width: 30,
	borderRadius: '50%',
	color: 'rgb(245, 244, 240)',
	backgroundColor: 'rgb(30, 20, 10)',
	cursor: 'pointer',
	border: 'none',
};

const prevPerPage = 10;

function HbsArchive({ bulletinData }) {
	const [page, setPage] = useState(1);
	const [pageList, setPageList] = useState([]);

	useEffect(() => {
		if (bulletinData) {
			setPageList(search(null, bulletinData));
		}
	}, [bulletinData]);

	return (
		<>
			<nav>
				<img
					className={styles.navLogo}
					height={50}
					width={50}
					src="imgs/hbs_logo.png"
					alt="HBS LOGO"
				/>
				<p className={styles.navItem}>거창고 학보사 아카이브</p>
			</nav>
			<div style={{ textAlign: 'center' }}>
				<div>
					<input
						type="text"
						placeholder="학보 검색하기"
						className={styles.searchBar}
						onKeyUp={(e) => {
							if (e.key === 'Enter')
								setPageList(search(e.target.value, bulletinData));
						}}
					/>
				</div>
				<div>
					{pageList.toReversed().map((value, i) => {
						if ((page - 1) * prevPerPage <= i && i < page * prevPerPage) {
							console.log(i);
							return <HbsPreview index={value} bulletinData={bulletinData} key={i} />;
						}
					})}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						marginBottom: 10,
					}}
				>
					<div>
						{pageList.length === 0
							? '학보가 없습니다 :('
							: [...Array(Math.ceil(pageList.length / prevPerPage))].map(
									(_, value) => (
										<button
											style={value + 1 === page ? s : n}
											className={styles.nonDrag}
											key={value}
											onClick={() => {
												setPage(value + 1);
											}}
										>
											{value + 1}
										</button>
									),
								)}
					</div>
				</div>
				<div>
					Contact us at <a href="mailto:geogohbs@gmail.com">geogohbs@gmail.com</a> or{' '}
					<a href="https://www.instagram.com/geogohbs/">our Instagram</a>
				</div>
				<br />
			</div>
		</>
	);
}

export default HbsArchive;
